/**
 * This component holds the whole app ui routing system, lazy loads private routes
 */
import OldGenericWrapper from "assets/js/components/GenericWrapper";
import { initPostHog } from "assets/js/const/SegmentEvents";
import LoggedOut from "assets/js/scenes/authFlow/containers/LoggedOut";
import OAuthCodeLogin from "assets/js/scenes/authFlow/containers/OAuthCodeLogin";
import OnboardingFlow from "assets/js/scenes/OnBoardingFlow/OnBoardingFlow";
import PublicHash from "assets/js/scenes/publicHash/PublicHash";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import { setLocalLocize } from "utils/languages";
import fetchRoute from "utils/routes";
import ErrorThrower from "./ErrorThrower";
import store from "./store";
import { addToImpersonificationTree, amIImpersonating, removeImpersonificationTree } from "./utils/apiUtils";
import { getUrlQueryParam, removeLegacyParameterByName } from "./utils/urlUtils";

const UI = lazy(() => import("assets/js/UI"));

function UIMain() {
	const [currentKey, setCurrentKey] = React.useState(amIImpersonating(true));
	useEffect(() => {
		const impersonateAccount = getUrlQueryParam("impersonate");

		if (impersonateAccount) {
			removeImpersonificationTree();
			addToImpersonificationTree(impersonateAccount);
			removeLegacyParameterByName("impersonate");
		}

		if (window.location.hash.includes(fetchRoute("public"))) {
			setLocalLocize();
		}
		if (!window.location.href.includes("#" + fetchRoute("listRedirections"))) {
			initPostHog(store.getState().brand?.client_config?.segment_config);
		}
	}, []);

	function refreshApp() {
		setCurrentKey(amIImpersonating(true));
	}

	const hashRoutes = !window.location.pathname.includes("public") && !window.location.pathname.includes("auth/callback");

	return <PostHogProvider client={posthog}>
		{!hashRoutes &&
			<BrowserRouter>
				<OldGenericWrapper>
					<ErrorThrower>
						<Suspense fallback={<></>}>
							<Switch key={currentKey}>
								<Route
									path={fetchRoute("public")}
									render={(props) => (
										<OnboardingFlow
											authenticated={false}
											fetchAccount={() => { }}
											{...props}
										/>
									)}
								/>
								<Route
									path={fetchRoute("oauthCodeCallback")}
									render={() => <OAuthCodeLogin />}
								/>
							</Switch>
						</Suspense>
					</ErrorThrower>
				</OldGenericWrapper>
			</BrowserRouter>
		}

		{hashRoutes &&
			<HashRouter>
				<OldGenericWrapper>
					<ErrorThrower>
						<Suspense fallback={<></>}>
							<Switch key={currentKey}>
								<Route
									path={fetchRoute("loggedOut")}
									render={() => <LoggedOut />}
								/>
								{!window.location.hash.includes(fetchRoute("public")) && <UI refreshApp={refreshApp} />}
								<Route
									path={fetchRoute("public")}
									render={() => <PublicHash />}
								/>
							</Switch>
						</Suspense>
					</ErrorThrower>
				</OldGenericWrapper>
			</HashRouter>
		}
	</PostHogProvider>
		;
}
export default UIMain;
